import { RegisterRequestedFieldType } from "../requested-field-types"
import { RequestedFieldInput, RequestedFieldValue } from "../share-link-fields-slot-definitions"
import { NumberFieldInput } from "../number-field-input"
import { NumberFieldValue } from "../number-field-value"

/**
 * Self-registering plugin for the "number" requested-field type. Registers the type's metadata and
 * plugs its recipient input + read-only value renderers.
 */
RegisterRequestedFieldType.handleOnce(({ types }) => types.push({ value: "number", label: "Number", priority: 30 }))

RequestedFieldInput("number").plug(<NumberFieldInput />)
RequestedFieldValue("number").plug(<NumberFieldValue />)
